/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FreightCalculatorFeeGroupVo } from './FreightCalculatorFeeGroupVo';
import {
    FreightCalculatorFeeGroupVoFromJSON,
    FreightCalculatorFeeGroupVoFromJSONTyped,
    FreightCalculatorFeeGroupVoToJSON,
    FreightCalculatorFeeGroupVoToJSONTyped,
} from './FreightCalculatorFeeGroupVo';
import type { DeliveryCalculationMemberGradeRespVo } from './DeliveryCalculationMemberGradeRespVo';
import {
    DeliveryCalculationMemberGradeRespVoFromJSON,
    DeliveryCalculationMemberGradeRespVoFromJSONTyped,
    DeliveryCalculationMemberGradeRespVoToJSON,
    DeliveryCalculationMemberGradeRespVoToJSONTyped,
} from './DeliveryCalculationMemberGradeRespVo';
import type { FreightCalculatorTransportMethodVo } from './FreightCalculatorTransportMethodVo';
import {
    FreightCalculatorTransportMethodVoFromJSON,
    FreightCalculatorTransportMethodVoFromJSONTyped,
    FreightCalculatorTransportMethodVoToJSON,
    FreightCalculatorTransportMethodVoToJSONTyped,
} from './FreightCalculatorTransportMethodVo';

/**
 * 
 * @export
 * @interface FreightCalculatorRespVo
 */
export interface FreightCalculatorRespVo {
    /**
     * 运输方式列表（固定五项）
     * @type {Array<FreightCalculatorTransportMethodVo>}
     * @memberof FreightCalculatorRespVo
     */
    transportMethods?: Array<FreightCalculatorTransportMethodVo>;
    /**
     * 运输类型选项（固定两项，index=4和5）
     * @type {Array<FreightCalculatorTransportMethodVo>}
     * @memberof FreightCalculatorRespVo
     */
    transportTypeOptions?: Array<FreightCalculatorTransportMethodVo>;
    /**
     * 会员等级选项
     * @type {Array<DeliveryCalculationMemberGradeRespVo>}
     * @memberof FreightCalculatorRespVo
     */
    memberGrades?: Array<DeliveryCalculationMemberGradeRespVo>;
    /**
     * 国际运费信息列表（按运输方式分组，共五套）
     * @type {Array<FreightCalculatorFeeGroupVo>}
     * @memberof FreightCalculatorRespVo
     */
    internationalFeeList?: Array<FreightCalculatorFeeGroupVo>;
}

/**
 * Check if a given object implements the FreightCalculatorRespVo interface.
 */
export function instanceOfFreightCalculatorRespVo(value: object): value is FreightCalculatorRespVo {
    return true;
}

export function FreightCalculatorRespVoFromJSON(json: any): FreightCalculatorRespVo {
    return FreightCalculatorRespVoFromJSONTyped(json, false);
}

export function FreightCalculatorRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreightCalculatorRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'transportMethods': json['transportMethods'] == null ? undefined : ((json['transportMethods'] as Array<any>).map(FreightCalculatorTransportMethodVoFromJSON)),
        'transportTypeOptions': json['transportTypeOptions'] == null ? undefined : ((json['transportTypeOptions'] as Array<any>).map(FreightCalculatorTransportMethodVoFromJSON)),
        'memberGrades': json['memberGrades'] == null ? undefined : ((json['memberGrades'] as Array<any>).map(DeliveryCalculationMemberGradeRespVoFromJSON)),
        'internationalFeeList': json['internationalFeeList'] == null ? undefined : ((json['internationalFeeList'] as Array<any>).map(FreightCalculatorFeeGroupVoFromJSON)),
    };
}

export function FreightCalculatorRespVoToJSON(json: any): FreightCalculatorRespVo {
    return FreightCalculatorRespVoToJSONTyped(json, false);
}

export function FreightCalculatorRespVoToJSONTyped(value?: FreightCalculatorRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transportMethods': value['transportMethods'] == null ? undefined : ((value['transportMethods'] as Array<any>).map(FreightCalculatorTransportMethodVoToJSON)),
        'transportTypeOptions': value['transportTypeOptions'] == null ? undefined : ((value['transportTypeOptions'] as Array<any>).map(FreightCalculatorTransportMethodVoToJSON)),
        'memberGrades': value['memberGrades'] == null ? undefined : ((value['memberGrades'] as Array<any>).map(DeliveryCalculationMemberGradeRespVoToJSON)),
        'internationalFeeList': value['internationalFeeList'] == null ? undefined : ((value['internationalFeeList'] as Array<any>).map(FreightCalculatorFeeGroupVoToJSON)),
    };
}

